/* istanbul ignore file */
import { Box, Typography } from '@mui/material';

const DateTimeDisplay = ({ value, type, hasMinus }: { value: number; type: string; hasMinus?: boolean }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="body1">
        {hasMinus && <Typography component="span">-</Typography>}
        {value < 10 ? `0${value}` : value}
      </Typography>

      <Typography variant="caption" color="textSecondary">
        {type}
      </Typography>
    </Box>
  );
};

export default DateTimeDisplay;
